
/**
 * The API returns "key details" as an object of id/type/typeDescriptor in an illogical and
 * semi-redundant way. The aim of the following code is to resolve these objects uniformly
 * to a human-readable label and ignore others that we no longer require.
 */

/**
 * These details list the verbs which correspond to supported sports. The detail 'type' appears
 * to refer to a taxonomy or category defined within the API which isn't used by the front-end.
 * The 'id' for the sport type refers to the sport discipline, where non-sport types don't need
 * an id and default to '1'.
 */
const details = {
  // '1001' type refers to sport
  1001: {
    3: 'Run', // Running
    10: 'Bike', // Cycling
    13: 'Run', // Obstacle
    15: 'Swim', // Swimming
    17: 'Hike', // Hiking
    19: 'Ski', // Skiing
    20: 'Kayak',
    21: 'Row', // Rowing
    22: 'SUP',
    23: 'Climb', // Climbing
    34: 'Run', // Train Run
    35: 'Run', // Road Run
    39: 'Bike', // Road Cycling
    49: 'Bike', // Mountain Biking
    50: 'Bike', // BMX
    51: 'Bike', // Fat Bike
    52: 'Bike', // Cyclocross
    53: 'Bike', // Track Cycling
    68: 'Swim', // Open Water Swim
    69: 'Swim', // Pool Swimming
    75: 'Hike', // Orienteering
    76: 'Ride', // Horseriding
    78: 'Ski', // Cross Country Ski
  },
  // The following types only have one 'id'
  1002: {
    1: 'Stages',
  },
  1003: {
    1: 'Obstacles',
  },
  1004: {
    1: 'Elev Gain',
  },
  1005: {
    1: 'Legs',
  },
};

// '1006' type also refers to sport, but the API doesn't resolve the duplication
details[1006] = details[1001];

/**
 * Attempt to get the detail (label) from configuration above by type/id combination.
 */
export default (type, id) => {
  // Detail type or ID may not exist
  try {
    // Resolve a string, or null if undefined
    return details[type][id] || null;
  } catch (e) {
    // TypeError: e.g. attempting to access ID when 'type' is not found
  }
  // Unsupported detail, return null
  return null;
};



// WEBPACK FOOTER //
// ./app/src/components/RaceSummary/helpers/getDetail.js